export default __webpack_public_path__ + "static/media/wordpress.460f6f16.svg";